export const DEBUG_MODE = process.env.NODE_ENV === "development";

export const LOCAL_URL = "/api-backend";
export const PROD_URL  = "/api";

const ENV_API_BASE = process.env.REACT_APP_API_BASE_URL;
export const BASE_URL = ENV_API_BASE
  ? ENV_API_BASE
  : DEBUG_MODE
    ? LOCAL_URL
    : PROD_URL;

const parseBool = (value, defaultValue = true) => {
  if (value === undefined || value === null) return defaultValue;
  if (typeof value === 'boolean') return value;
  const normalized = String(value).trim().toLowerCase();
  if (['1', 'true', 'yes', 'on'].includes(normalized)) return true;
  if (['0', 'false', 'no', 'off'].includes(normalized)) return false;
  return defaultValue;
};

const sanitizeUrl = (value, fallback) => {
  if (!value || typeof value !== 'string') return fallback;
  try {
    const normalized = value.trim();
    if (!normalized) return fallback;
    const candidate = normalized.startsWith('http')
      ? normalized
      : `${fallback.replace(/\/$/, '')}/${normalized.replace(/^\//, '')}`;
    const url = new URL(candidate);
    const pathname = url.pathname === '/' ? '' : url.pathname.replace(/\/$/, '');
    return `${url.origin}${pathname}`;
  } catch {
    return fallback;
  }
};

const defaultMembersUrl = DEBUG_MODE
  ? 'http://localhost:3002'
  : 'https://members.solo-line.com';

export const MEMBERS_APP_URL = sanitizeUrl(
  process.env.REACT_APP_MEMBERS_APP_URL,
  defaultMembersUrl
) || defaultMembersUrl;

const defaultLoginPath = process.env.REACT_APP_MEMBERS_LOGIN_PATH || '/login';

export const MEMBERS_LOGIN_URL = (() => {
  const base = MEMBERS_APP_URL.replace(/\/$/, '');
  return `${base}${defaultLoginPath.startsWith('/') ? '' : '/'}${defaultLoginPath.replace(/^\/?/, '/')}`;
})();

export const REQUIRE_EDITOR_LOGIN = parseBool(
  process.env.REACT_APP_REQUIRE_EDITOR_LOGIN,
  true
);
